import {
    FETCH_BULK_REFUND_REQUEST,
    FETCH_BULK_REFUND_SUCCESS,
    FETCH_BULK_REFUND_ERROR,
    HIDE_BULK_REFUND_LOADER,
    SHOW_BULK_REFUND_LOADER,
    UPLOAD_BULK_REFUND_FILE_REQUEST,
    UPLOAD_BULK_REFUND_FILE_SUCCESS,
    UPLOAD_BULK_REFUND_FILE_ERROR,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_SUCCESS,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_ERROR,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_SUCCESS,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_ERROR,
    FETCH_BULK_REFUND_BY_ID_REQUEST,
    FETCH_BULK_REFUND_BY_ID_SUCCESS,
    FETCH_BULK_REFUND_BY_ID_ERROR,
} from './bulkRefund.constants';

export const fetchBulkRefundDataRequest = payload => ({
    type: FETCH_BULK_REFUND_REQUEST,
    payload,
});

export const fetchBulkRefundDataSuccess = payload => ({
    type: FETCH_BULK_REFUND_SUCCESS,
    payload,
});

export const fetchBulkRefundDataError = payload => ({
    type: FETCH_BULK_REFUND_ERROR,
    payload,
});

export const uploadBulkUploadFileRequest = payload => ({
    type: UPLOAD_BULK_REFUND_FILE_REQUEST,
    payload,
});

export const uploadBulkUploadFileSuccess = payload => ({
    type: UPLOAD_BULK_REFUND_FILE_SUCCESS,
    payload,
});

export const uploadBulkUploadFileError = payload => ({
    type: UPLOAD_BULK_REFUND_FILE_ERROR,
    payload,
});

export const fetchBulkRefundFileTableDataByIdRequest = payload => ({
    type: FETCH_BULK_REFUND_BY_ID_REQUEST,
    payload,
});

export const fetchBulkRefundFileTableDataByIdSuccess = payload => ({
    type: FETCH_BULK_REFUND_BY_ID_SUCCESS,
    payload,
});

export const fetchBulkRefundFileTableDataByIdError = payload => ({
    type: FETCH_BULK_REFUND_BY_ID_ERROR,
    payload,
});

export const downloadBulkRefundFileByIdRequest = payload => ({
    type: DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST,
    payload,
});

export const downloadBulkRefundFileByIdSuccess = payload => ({
    type: DOWNLOAD_BULK_REFUND_FILE_BY_ID_SUCCESS,
    payload,
});

export const downloadBulkRefundFileByIdError = payload => ({
    type: DOWNLOAD_BULK_REFUND_FILE_BY_ID_ERROR,
    payload,
});

export const downloadBulkRefundPreFilledFileRequest = payload => ({
    type: DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST,
    payload,
});

export const downloadBulkRefundPreFilledFileSuccess = payload => ({
    type: DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_SUCCESS,
    payload,
});

export const downloadBulkRefundPreFilledFileError = payload => ({
    type: DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_BULK_REFUND_LOADER });

export const hideLoader = () => ({ type: HIDE_BULK_REFUND_LOADER });
